const initialiseKnowledgeArticles = () => {
  document.querySelectorAll('[data-fg-knowledge-article]').forEach((articlePage) => {
    const articleBody = articlePage.querySelector('[data-fg-article-body]');
    const toc = articlePage.querySelector('[data-fg-toc]');
    const tocList = articlePage.querySelector('[data-fg-toc-list]');

    if (!articleBody || !toc || !tocList) return;

    const headings = [...articleBody.querySelectorAll('h2')];
    if (headings.length < 3) return;

    const usedIds = new Set();
    const fragment = document.createDocumentFragment();

    headings.forEach((heading, index) => {
      const baseId = (heading.textContent || '')
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;

      let headingId = heading.id || baseId;
      let suffix = 2;
      while (usedIds.has(headingId)) {
        headingId = `${baseId}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(headingId);
      heading.id = headingId;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${headingId}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      fragment.appendChild(item);
    });

    tocList.replaceChildren(fragment);
    toc.hidden = false;
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseKnowledgeArticles, { once: true });
} else {
  initialiseKnowledgeArticles();
}
